import script from "./TransferTypeTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferTypeTabs.vue?vue&type=script&setup=true&lang=js"

import "./TransferTypeTabs.vue?vue&type=style&index=0&id=683fc0cb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683fc0cb"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Intersection from 'quasar/src/directives/intersection/Intersection.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QIcon});qInstall(script, 'directives', {Intersection});
